import { createSelector } from 'reselect';
import { subselect } from './root';
import { propertiesSelector } from './properties';

const fetchByIdSelector = createSelector([propertiesSelector], ({ entities }) => (id) =>
  entities.vodContent && entities.vodContent[id] ? entities.vodContent[id] : null,
);

export const vodContentFetchItemByIdSelector = subselect(fetchByIdSelector);
